module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yeti-map",
    style: ({
      'background-image': 'url(' + _vm.currentPhase.mapImage + ')'
    })
  }, [_c('div', {
    staticClass: "yeti-map__message",
    domProps: {
      "innerHTML": _vm._s(_vm.currentPhase.messages[_vm.lang])
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "yeti-map__uninversities",
    attrs: {
      "src": _vm.currentPhase.universityImage
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-247b28de","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YetiMap.vue
// module id = 172
// module chunks = 0